import { ACTIONS, MUTATIONS } from '../constants';
import { yoyoHttp } from '../../services/http.service';

const actions = {
    async [ACTIONS.UPLOAD_DOCUMENT.FETCH_SHIPMENT_DOCUMENT_TYPES](ctx) {
        const r = await yoyoHttp.cachedGet('api/StaticData/GetShipmentDocumentTypes', null);

        if (r.status === 200) {
            ctx.commit(MUTATIONS.UPLOAD_DOCUMENT.SET_SHIPMENT_DOCUMENT_TYPES, r.data);
        }
    },

    async [ACTIONS.UPLOAD_DOCUMENT.POST_UPLOAD_DOCUMENT](ctx, payLoad) {
        
        const r = await yoyoHttp.post('api/Shipment/PostUploadFiles?linkId=', payLoad);

        ctx.commit(MUTATIONS.UPLOAD_DOCUMENT.SET_UPLOAD_RESPONSE, r.data);
    },

    async [ACTIONS.UPLOAD_DOCUMENT.POST_UPLOAD_DOCUMENT2](ctx, payLoad) {

        const r = await yoyoHttp.post('api/Shipment/PostUploadFiles?linkId=' + payLoad.linkId, payLoad.formData);
        

        ctx.commit(MUTATIONS.UPLOAD_DOCUMENT.SET_UPLOAD_RESPONSE, r.data);
    }
};

export default actions;
